import { useCallback } from 'react';

import { getMockImage } from './getMockImage';
import type {
  OnBeforeUploadResult,
  UploadHookParams,
  UploadHookResult,
} from './types';

export const useMockUpload = ({
  onBeforeUploadBegin,
  onUploadComplete,
  onUploadError,
  onUploadCancelled,
}: UploadHookParams): UploadHookResult => {
  const upload = useCallback(
    async (file: File) => {
      try {
        // Mock implementation
        const beforeResult: OnBeforeUploadResult = onBeforeUploadBegin
          ? await onBeforeUploadBegin(file)
          : { type: 'continue', file };

        if (beforeResult.type === 'cancel')
          return onUploadCancelled?.('user_cancelled');

        if (beforeResult.type === 'error')
          return onUploadError(beforeResult.error);

        // Generate mock result using the same approach as the old component
        const mockResult = getMockImage();

        // Simulate a slight delay
        setTimeout(() => {
          onUploadComplete(mockResult);
        }, 500);
      } catch (error: unknown) {
        if (error instanceof Error) return onUploadError(error);
        if (typeof error === 'string') return onUploadError(new Error(error));
        return onUploadError(new Error(`Unknown error: ${String(error)}`));
      }
    },
    [onBeforeUploadBegin, onUploadCancelled, onUploadComplete, onUploadError],
  );

  return { upload };
};
